import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorGeoInfosResolver: FieldResolver = (metadata: Metadata) =>
  ({ authorGeoInfos: metadata.getAuthorGeoInfos() } as StreamData)

export default authorGeoInfosResolver
